export default __webpack_public_path__ + "static/media/cross.d4baade2.svg";